import { UpdateTemplateItem } from './UpdateTemplateItem';

export class UpdateTemplate {

  constructor(
    public id?: string,   
    public name?: string,
    public customerId?: string,
    public addNewChilds?: boolean,
    public ignoreEmptyValues?: boolean,
    public items?: UpdateTemplateItem[],


     
  ) {
  }
}


